export const CONTACT = {
  phone: "+1 514 621-4802",
  email: "info@emergence-prudhomme.com",
  location: "En personne & en visioconférence",
  linkedin: "https://www.linkedin.com/in/jane-soleil-prudhomme-c-o",
  facebook: "https://www.facebook.com/61593554697849",
};

export const SIGNATURE = ["Comprendre", "Restaurer", "Grandir", "Donner du sens", "Avancer"];

export const IMAGES = {
  hero: "/images/hero-emergence.webp",
  growth: "/images/arroser.webp",
  freedom: "/images/joie7.webp",
  umbrella: "/images/joie4.webp",
  listening: "/images/therapie3.webp",
  direction: "/images/therapie4.webp",
  coeurMission: "/images/coeur-mission.webp",
  training: "/images/jane-formation.webp",
  therapyRoom: "/images/photo-salle-consultation.webp",
  hands: "/images/photo-mains-solidaires.webp",
  journal: "/images/photo-journal-reflexion.webp",
  sunrisePath: "/images/photo-chemin-aurore.webp",
  movement: "https://images.unsplash.com/photo-1552650272-b8a34e21bc4b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxzZXJlbmUlMjBwZWFjZWZ1bCUyMG5hdHVyYWwlMjBsaWdodCUyMHdvbWFufGVufDB8fHx8MTc4NzAxMTMzMnww&ixlib=rb-4.1.0&q=85",
  portrait: "/jane-prudhomme.webp",
  leaves: "https://images.unsplash.com/photo-1679060170179-c384186c87ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxzYWdlJTIwZ3JlZW4lMjBuYXR1cmUlMjBsZWF2ZXMlMjBjYWxtfGVufDB8fHx8MTc4NzAxMTMzMnww&ixlib=rb-4.1.0&q=85",
};

const THERAPY_SERVICES = [
  {
    slug: "soutien-therapeutique-mieux-etre",
    title: "Soutien thérapeutique & mieux-être",
    intro: "Retrouver l'équilibre — un soutien pour les moments où la vie pèse plus lourd :",
    bullets: [
      "Stress, anxiété et surcharge mentale",
      "Tristesse persistante, dépression",
      "Deuil et pertes",
      "Séparations",
      "Transitions et changements de vie",
      "Changements et difficultés professionnelles",
      "Intégration de bonnes habitudes de vie",
    ],
    closing: "Un accompagnement pour apaiser votre esprit, comprendre vos émotions et retrouver stabilité et mieux-être au quotidien.",
  },
  {
    slug: "croissance-personnelle",
    title: "Croissance personnelle",
    intro: "Mieux se connaître — un accompagnement pour développer vos ressources intérieures :",
    bullets: [
      "Connaissance de soi",
      "Estime et confiance en soi",
      "Gestion des émotions",
      "Affirmation de soi",
      "Relations et communication",
      "Développement des forces personnelles",
      "Résilience",
    ],
    closing: "Pour développer vos ressources, renforcer votre confiance et avancer avec plus de clarté et d'authenticité.",
  },
  {
    slug: "orientation-professionnelle",
    title: "Orientation professionnelle",
    intro: "Trouver sa direction — un accompagnement pour éclairer votre parcours professionnel :",
    bullets: [
      "Orientation et réorientation",
      "Exploration des intérêts, talents et compétences",
      "Valeurs, forces et aspirations",
      "Changement de carrière",
      "Recherche de sens et vocation",
      "Choix professionnels éclairés",
    ],
    closing: "Un espace pour clarifier votre projet professionnel et faire des choix alignés avec vos valeurs et votre identité.",
  },
  {
    slug: "accompagnement-psychospirituel-chretien",
    title: "Accompagnement psychospirituel chrétien",
    intro: "Donner du sens — un accompagnement pour les personnes qui souhaitent intégrer leur foi dans leur démarche :",
    bullets: [
      "Les questionnements existentiels",
      "Recherche de sens",
      "Découverte et approfondissement de la relation avec Dieu",
      "Prière, Écritures et vie spirituelle",
      "Discernement et vocation",
      "Pardon, espérance et paix intérieure",
      "Intégration de la foi dans la vie quotidienne",
    ],
    closing: "Un accompagnement pour nourrir votre foi, grandir spirituellement et vivre une relation plus profonde avec Dieu.",
  },
];

export const PARTICULIERS = {
  label: "Services aux particuliers",
  subtitle: "Thérapie & formation en croissance personnelle et psychospirituelle",
  taglines: ["Comprendre.", "Restaurer.", "Grandir."],
  intro: [
    "La vie nous amène parfois à des périodes de doute, de fatigue, de transition ou de questionnement. Vous n'avez pas à traverser cela seul(e).",
    "Je vous accompagne avec écoute, respect et bienveillance pour vous aider à mieux comprendre ce que vous vivez, retrouver votre équilibre et avancer vers une vie plus alignée avec qui vous êtes.",
  ],
  highlight: "Vous méritez de vous sentir bien, aligné(e) et en paix.",
  therapyLabel: "Thérapie",
  therapyIntro: "Quatre accompagnements complémentaires, pensés pour vous rencontrer là où vous êtes.",
  services: THERAPY_SERVICES,
  formation: {
    label: "Formation",
    intro: "Des formations pratiques et réflexives pour outiller votre cheminement personnel et spirituel, en individuel ou en petit groupe.",
    bullets: [
      "Connaissance de soi et intelligence émotionnelle",
      "Estime et affirmation de soi",
      "Traverser les transitions de vie avec clarté",
      "Découvrir sa vocation et donner du sens à son parcours",
      "Croissance spirituelle et vie de foi",
    ],
    closing: "Chaque formation peut être suivie en personne ou en visioconférence, à votre rythme.",
  },
  cta: {
    heading: "La démarche commence là où vous êtes.",
    text: "Vous pouvez venir simplement avec une question, un sentiment de confusion, une transition, un désir de changement ou le besoin de faire le point.",
    button: "Prendre rendez-vous",
  },
};

export const SERVICE_CATEGORIES = [
  {
    id: "01",
    slug: "services-aux-particuliers",
    title: "Services aux particuliers",
    short: "Thérapie et formation pour mieux vous connaître, traverser les transitions et grandir.",
    intro: "La vie nous amène parfois à des périodes de doute, de fatigue, de transition ou de questionnement. Vous n'avez pas à traverser cela seul(e).",
    bullets: [
      "Soutien thérapeutique & mieux-être — Retrouver l'équilibre",
      "Croissance personnelle — Mieux se connaître",
      "Orientation professionnelle — Trouver sa direction",
      "Accompagnement psychospirituel chrétien — Donner du sens",
      "Formations pratiques et réflexives",
    ],
    closing: "Je vous accompagne avec écoute, respect et bienveillance pour vous aider à mieux comprendre ce que vous vivez, retrouver votre équilibre et avancer vers une vie plus alignée avec qui vous êtes.",
    link: { to: "/particuliers", label: "Découvrir l'offre pour les particuliers" },
  },
  {
    id: "02",
    slug: "services-aux-entreprises",
    title: "Services aux entreprises",
    short: "Consultation, service-conseil et formations sur mesure pour prendre soin de vos équipes.",
    intro: "Des solutions humaines et efficaces pour des milieux de travail sains, engagés et performants.",
    bullets: [
      "Coaching de gestion",
      "Développement du leadership",
      "Mieux-être au travail",
      "Diagnostic du climat de travail",
      "Gestion et résolution de conflits",
      "Développement des talents",
      "Gestion de la relève",
      "Gestion de la performance",
      "Développement professionnel",
      "Formation sur mesure",
    ],
    closing: "Des personnes épanouies. Des équipes engagées. Des organisations performantes.",
    link: { to: "/entreprises", label: "Découvrir l'offre complète pour les entreprises" },
  },
  {
    id: "03",
    slug: "soutien-a-la-communaute",
    title: "Soutien à la communauté",
    short: "Une présence qui réconforte, une écoute qui accueille, une main qui soutient.",
    intro: "Faire connaître l'amour de Jésus par des actions concrètes, en offrant une présence bienveillante aux personnes qui vivent la solitude, la maladie, la précarité, l'isolement ou des périodes de grande vulnérabilité.",
    bullets: [
      "Écoute et accompagnement",
      "Ligne de soutien téléphonique",
      "Accompagnement psychologique et spirituel",
      "Visite et soutien auprès des personnes malades",
      "Visite et accompagnement en milieu de détention",
      "Soutien à domicile",
      "Popote roulante et aide alimentaire",
      "Dons et distribution de biens essentiels",
    ],
    closing: "Nous souhaitons être là pour écouter, encourager, soutenir et redonner espoir.",
    logo: "/images/coeur-mission.webp",
    logoAlt: "Logo Cœur Mission — Aimer. Soutenir. Prier",
    link: { to: "/communaute", label: "Découvrir nos services communautaires" },
  },
];

export const ENTREPRISES = {
  subtitle: "Service conseil RH | Mieux-être. Leadership. Performance.",
  taglines: ["Des personnes épanouies.", "Des équipes engagées.", "Des organisations performantes."],
  intro: [
    "Des solutions humaines et efficaces pour des milieux de travail sains, engagés et performants.",
    "J'accompagne les organisations qui souhaitent développer leur capital humain, améliorer le mieux-être au travail et créer des environnements où les personnes peuvent collaborer, s'épanouir et donner le meilleur d'elles-mêmes.",
    "Une approche humaine, intégrative et personnalisée qui tient compte de la santé globale de la personne : physique, psychologique, émotionnelle, relationnelle et spirituelle.",
  ],
  mission: "Ensemble, faisons grandir vos équipes et faire rayonner votre organisation.",
  services: [
    {
      id: "01",
      title: "Coaching de gestion",
      intro: "Accompagnement personnalisé des gestionnaires pour mieux relever leurs défis, développer leurs compétences et exercer leur rôle avec confiance et efficacité.",
    },
    {
      id: "02",
      title: "Développement du leadership",
      intro: "Développer un leadership authentique, mobilisateur et humain afin d'inspirer, communiquer efficacement, prendre des décisions et mobiliser les équipes.",
    },
    {
      id: "03",
      title: "Mieux-être au travail",
      intro: "Favoriser un environnement de travail sain en agissant sur le stress, la surcharge, l'équilibre, les relations et les ressources individuelles et collectives.",
    },
    {
      id: "04",
      title: "Diagnostic du climat de travail",
      intro: "Comprendre la réalité de votre organisation, identifier les forces et les enjeux et dégager des pistes d'action concrètes pour améliorer le climat de travail.",
    },
    {
      id: "05",
      title: "Gestion et résolution de conflits",
      intro: "Intervenir lorsque les tensions nuisent à la collaboration et à la performance. Favoriser le dialogue, la compréhension mutuelle et des solutions durables.",
    },
    {
      id: "06",
      title: "Développement des talents",
      intro: "Identifier, valoriser et développer les talents de vos équipes pour renforcer l'engagement et maximiser le potentiel individuel et collectif.",
    },
    {
      id: "07",
      title: "Gestion de la relève",
      intro: "Préparer l'avenir en identifiant les personnes à potentiel, en développant leurs compétences et en assurant une transition harmonieuse des responsabilités.",
    },
    {
      id: "08",
      title: "Gestion de la performance",
      intro: "Clarifier les attentes, soutenir le développement, offrir une rétroaction constructive et accompagner les employés vers l'atteinte de leurs objectifs.",
    },
    {
      id: "09",
      title: "Développement professionnel",
      intro: "Accompagner les employés et gestionnaires dans leur évolution professionnelle, le développement de leurs compétences et la réalisation de leur plein potentiel.",
    },
    {
      id: "10",
      title: "Formation sur mesure",
      intro: "Des formations adaptées à vos besoins et à votre réalité. Thèmes populaires : leadership, communication, gestion des conflits, mieux-être, collaboration, performance, etc.",
    },
  ],
  reasons: [
    {
      title: "Une expertise multidisciplinaire",
      text: "Mon expérience en RH, développement organisationnel, formation, coaching et orientation professionnelle me permet d'avoir une vision globale des enjeux humains et organisationnels.",
    },
    {
      title: "Une approche pragmatique",
      text: "Je privilégie les solutions concrètes, applicables et adaptées à votre réalité plutôt que les approches théoriques qui restent sans lendemain.",
    },
    {
      title: "Une approche personnalisée",
      text: "Chaque organisation possède sa culture, ses enjeux et ses objectifs. Mes interventions sont donc adaptées à votre contexte.",
    },
    {
      title: "Une orientation vers les résultats",
      text: "L'objectif de chaque intervention est de créer une valeur réelle pour l'organisation et les personnes qui la composent.",
    },
    {
      title: "Une approche humaine",
      text: "Performance et bien-être ne sont pas incompatibles. Des employés mieux accompagnés, des gestionnaires mieux outillés et des équipes plus mobilisées constituent des leviers importants de réussite organisationnelle.",
    },
  ],
  profile: {
    name: "Jane Prudhomme",
    role: "Consultante, Coach et Formatrice | Mieux-être au travail • Leadership • Performance",
    paragraphs: [
      "Passionnée par le développement du leadership, le potentiel humain et la performance organisationnelle, j'exerce depuis plus de 15 ans à titre de consultante RH, professionnelle en développement organisationnel, formatrice et coach.",
      "Au fil de mon parcours, j'ai eu le privilège d'accompagner des personnes, des gestionnaires et des organisations provenant de différents secteurs d'activité, dans leurs enjeux de développement, de performance et de transformation.",
      "De nature pragmatique, créative et orientée vers les solutions, j'aime travailler en collaboration avec mes clients afin de comprendre leur réalité, identifier les véritables enjeux et construire des stratégies concrètes permettant d'obtenir des résultats durables. Ma plus grande fierté est d'avoir contribué, au fil des années, au développement et à la réussite professionnelle de nombreuses personnes et organisations.",
    ],
    mission: "Accompagner les organisations et les individus à développer leur plein potentiel, accroître leur performance, renforcer leurs compétences, favoriser le bien-être et créer des environnements de travail où les personnes peuvent réellement s'épanouir.",
  },
  cta: {
    heading: "Parlons de vos enjeux",
    text: "Vous faites face à un défi de gestion, de climat de travail, de mobilisation ou de développement des compétences ? Vous souhaitez mieux outiller vos gestionnaires, renforcer votre équipe ou mettre en place une démarche adaptée à votre organisation ? Une première discussion permet de comprendre votre situation, de cibler vos besoins et d'identifier les solutions les plus pertinentes pour votre organisation.",
    buttons: ["Planifier une consultation", "Demander une proposition de formation", "Me parler de votre besoin"],
  },
};

export const FAQS = [
  {
    q: "Comment se déroule une première rencontre ?",
    a: "La première rencontre est un temps d'accueil et d'écoute. Nous prenons le temps de comprendre ce qui vous amène, vos besoins et ce que vous souhaitez explorer. Vous n'avez rien à préparer — la démarche commence là où vous êtes.",
  },
  {
    q: "Quelle est la durée et la fréquence des séances ?",
    a: "Les séances durent environ 60 minutes. Le rythme est adapté à votre réalité : hebdomadaire, aux deux semaines ou selon vos besoins. Nous en discutons ensemble lors des premières rencontres.",
  },
  {
    q: "Faut-il partager la foi chrétienne pour être accompagné·e ?",
    a: "Non. L'accompagnement est ouvert à toute personne, quelle que soit sa conviction. L'intégration de la foi chrétienne, des Écritures et de la prière est proposée uniquement aux personnes qui le désirent explicitement.",
  },
  {
    q: "Quelle est la différence avec une psychothérapie ?",
    a: "Mon approche est centrée sur la croissance personnelle, le sens, l'identité et l'accompagnement dans les transitions. Elle ne remplace pas un suivi médical, psychiatrique ou un traitement en cours — elle peut toutefois s'y intégrer harmonieusement.",
  },
  {
    q: "Les échanges sont-ils confidentiels ?",
    a: "Oui, absolument. Tout ce qui est partagé en séance demeure strictement confidentiel. Cet espace de confiance est le fondement de tout le travail que nous faisons ensemble.",
  },
  {
    q: "Offrez-vous des rencontres à distance ?",
    a: "Oui. Les rencontres peuvent se dérouler en personne ou en visioconférence, selon ce qui vous convient le mieux. La qualité de l'accompagnement demeure la même dans les deux formats.",
  },
];

export const TESTIMONIALS = [
  {
    quote: "J'arrivais dans une période de brouillard complet. J'ai été accueillie sans jugement, avec une écoute rare. Séance après séance, j'ai retrouvé une direction — et surtout, je me suis retrouvée.",
    author: "M., 38 ans",
    context: "Accompagnement en transition de vie",
  },
  {
    quote: "Un espace précieux où l'on peut parler de tout, y compris de sa foi, en toute liberté. J'ai pu intégrer ma relation avec Dieu dans mon cheminement personnel comme jamais auparavant.",
    author: "D., 45 ans",
    context: "Croissance spirituelle chrétienne",
  },
  {
    quote: "Les séances m'ont aidée à mieux me connaître, à reconnaître mes forces et à reprendre confiance en moi. Je recommande à quiconque traverse une période de questionnement.",
    author: "S., 29 ans",
    context: "Croissance personnelle",
  },
  {
    quote: "Jane est une collègue et une professionnelle attentionnée et débordante d'une belle énergie. Elle sait offrir un climat d'écoute et d'accueil pour tous ses clients. C'est une conseillère expérimentée qui sait cibler les besoins des clients. Elle n'hésite pas à servir de mentor à ses collègues et s'implique avec rigueur dans la création de nouveaux outils. C'est surtout la personne qu'elle est qui fait d'elle une conseillère d'orientation hors pair et compétente.",
    author: "Kathleen Synotte, B. Sc. CRIA",
    context: "Conseillère ressources humaines — Recommandation LinkedIn, 2018",
  },
  {
    quote: "Au cours de mon parcours professionnel, j'ai eu le plaisir de travailler en présence d'une professionnelle accomplie, dotée d'une grande sensibilité et d'humanité pour accompagner les clients dans la découverte de leurs aspirations professionnelles. J'ai été témoin de nombreux cas de succès où Jane, par ses interventions, a pu amener les clients vers l'atteinte de leurs objectifs professionnels et personnels. Forte de ses compétences en counseling d'emploi, orientation professionnelle, information scolaire et professionnelle, intervention interculturelle et approche globale, je n'hésite nullement à recommander Jane à toute personne souhaitant découvrir son plein potentiel.",
    author: "Marjorie Casimir",
    context: "Conseillère RC — Qualifications Québec — Recommandation LinkedIn, 2018",
  },
  {
    quote: "Jane Prudhomme est une remarquable conseillère d'orientation, toujours à l'écoute des besoins des clients ; elle cible les outils qu'elle utilisera pour chacune des personnes rencontrées en fonction de sa situation et de sa demande. Elle regorge de connaissances en santé mentale et en accompagnement aux nouveaux arrivants, et elle est parfaitement bilingue, un atout considérable. Sa faculté à orienter le client vers un résultat concret et rapide est notable. Travailler en équipe avec Jane est un réel plaisir : elle est à l'écoute de ses collaborateurs et les guide dans leurs recherches.",
    author: "Marie Gaudin",
    context: "Conseillère RH et partenaire d'affaires — Recommandation LinkedIn, 2018",
  },
  {
    quote: "Jane a rendu des services appréciables en consultation et en soutien à l'apprentissage. Elle a animé de nombreux ateliers, accompagné les étudiants en consultation individuelle et su tisser des liens de confiance favorisant la communication et l'entraide. Son engagement est reconnu par l'ensemble de ses collègues.",
    author: "Nicole Bonenfant",
    context: "Directrice des Services-Conseils, Services à la vie étudiante — UQAM, 2013",
  },
  {
    quote: "Bénévole écoutante au Centre d'écoute Halte Ami, Jane a suivi une formation de 60 heures en relation d'aide et en intervention de crise, et s'est impliquée auprès des nouveaux arrivants comme animatrice de groupes de conversation en français.",
    author: "Véronique Frenette",
    context: "Coordonnatrice des bénévoles, Centre d'écoute et de référence Halte Ami — UQAM, 2010",
  },
  {
    quote: "Jane fait preuve d'une grande capacité d'adaptation, d'un bon jugement et d'un entregent remarquable.",
    author: "Danielle Piché",
    context: "COOPSCO Trois-Rivières, 2007",
  },
];

export const FORMATION_STATS = [
  { value: "8", label: "années d'études universitaires au Canada" },
  { value: "15+", label: "années d'expérience" },
];

export const FORMATION_INTRO =
  "Une expertise multidisciplinaire en psychologie, orientation professionnelle, ressources humaines et développement organisationnel, mise au service du développement des personnes et de la performance des organisations. Des formations pratiques, humaines et adaptées aux réalités professionnelles — j'ai continuellement enrichi ma pratique par des formations spécialisées.";

export const CERTIFICATIONS = [
  { title: "Coaching de gestion", year: "2024" },
  { title: "Certificat en études spirituelles chrétiennes", year: "2019" },
  { title: "Diagnostic identitaire et utilisation de l'épreuve de groupement en counseling d'orientation", year: "2016" },
  { title: "Approche psychogénétique du développement identitaire — Institut de recherche et clinique en psychologie", year: "2016" },
  { title: "Acceptance and Commitment Therapy (ACT)", year: "2015" },
  { title: "Intervenir auprès d'une clientèle réfractaire", year: "2015" },
  { title: "Intervenir auprès des personnes suicidaires — Association québécoise de prévention du suicide", year: "2013" },
  { title: "Évaluer le retard mental en orientation — UQAM", year: "2012" },
  { title: "Le choc culturel vécu chez les intervenants en contexte pluriethnique — ROSINI", year: "2010" },
];

export const CLIENTS = [
  { initials: "CIUSSS", name: "CIUSSS du Centre-Sud-de-l'Île-de-Montréal" },
  { initials: "AR", name: "Action RH Lanaudière" },
  { initials: "CSL", name: "Commission scolaire de Laval" },
  { initials: "BL", name: "Brisson Legris — Montréal" },
  { initials: "GCSD", name: "Groupe conseil Saint-Denis — Montréal" },
  { initials: "UQAM", name: "Université du Québec à Montréal" },
  { initials: "CSDM", name: "Commission scolaire de Montréal" },
  { initials: "OE", name: "Organisme Objectif emploi" },
  { initials: "MIRS", name: "Maison internationale de la Rive-Sud — Montréal" },
  { initials: "CLAM", name: "Carrefour de liaison et d'aide multiethnique" },
];

export const TARIFS_PARTICULIERS = [
  { title: "Accompagnement thérapeutique", duration: "60 min", price: "150 $" },
  { title: "Coaching individuel", duration: "60 min", price: "165 $" },
  { title: "Formation individuelle / atelier", duration: "2 h", price: "125 $", note: "par personne" },
  { title: "Formation individuelle / journée", duration: "6–7 h", price: "375 $", note: "par personne" },
  { title: "Consultation initiale", duration: "20 min", price: "Gratuite", highlight: true },
];

export const TARIF_SOLIDAIRE = {
  title: "Tarif solidaire",
  text: "Parce que l'accessibilité fait partie de nos valeurs, quelques places à tarif réduit sont offertes chaque mois aux personnes vivant une situation financière difficile.",
  price: "À partir de 90 $ la séance, selon la situation.",
};

export const TARIFS_ENTREPRISES = {
  coachingLabel: "Coaching de gestion",
  coaching: [
    { title: "Coaching individuel de gestion", duration: "60 min", price: "225 $" },
    { title: "Forfait 4 rencontres", duration: "4 × 60 min", price: "800 $", note: "soit 200 $ la rencontre" },
    { title: "Forfait 6 rencontres", duration: "6 × 60 min", price: "1 125 $", note: "soit 187,50 $ la rencontre" },
  ],
  formationLabel: "Formation en entreprise",
  formation: [
    { title: "Conférence / atelier", duration: "60 à 90 min", price: "500 $ à 750 $" },
    { title: "Atelier", duration: "2 h", price: "750 $ à 1 000 $" },
    { title: "Demi-journée de formation", duration: "3 h", price: "1 100 $ à 1 400 $" },
    { title: "Journée complète", duration: "6 h", price: "1 800 $ à 2 400 $" },
  ],
  diagnostic: {
    title: "Diagnostic du climat organisationnel et plan d'action",
    price: "À partir de 1 500 $",
    text: "Une analyse complète du climat de travail de votre organisation, suivie d'un plan d'action concret et adapté à vos réalités.",
  },
  surMesure: {
    title: "Formation personnalisée pour une organisation",
    price: "À partir de 1 500 $",
    text: "Prix établi selon le nombre de participants, la personnalisation et les besoins de l'organisation.",
  },
};

export const DEMARCHE_MOTIFS = [
  "Mieux vous connaître",
  "Retrouver confiance en vous",
  "Mieux gérer vos émotions",
  "Traverser une transition",
  "Réfléchir à votre avenir professionnel",
  "Clarifier vos valeurs et vos priorités",
  "Découvrir votre vocation",
  "Retrouver un sens à votre parcours",
  "Approfondir votre vie spirituelle",
  "Intégrer votre foi chrétienne dans votre cheminement",
];

export const COMMUNAUTE = {
  label: "Soutien à la communauté",
  taglines: ["Une présence qui réconforte.", "Une écoute qui accueille.", "Une main qui soutient."],
  intro: [
    "Nous croyons que l'amour de Jésus se manifeste aussi par des gestes concrets de compassion, de solidarité et de présence auprès de ceux qui traversent des moments difficiles.",
    "Notre mission est de faire connaître l'amour de Jésus par des actions concrètes, en offrant une présence bienveillante aux personnes qui vivent la solitude, la maladie, la précarité, l'isolement ou des périodes de grande vulnérabilité.",
  ],
  highlight: "Nous souhaitons être là pour écouter, encourager, soutenir et redonner espoir.",
  supportLine: {
    phone: "+1 514 621-4802",
    hours: [
      { days: "Lundi au vendredi", time: "4 h à 19 h" },
      { days: "Samedi", time: "Toute la journée" },
    ],
  },
  services: [
    {
      icon: "HeartHandshake",
      title: "Écoute et accompagnement",
      text: "Un espace confidentiel et bienveillant pour déposer ce que l'on vit, être écouté sans jugement et recevoir du soutien dans les moments difficiles.",
    },
    {
      icon: "Phone",
      title: "Ligne de soutien téléphonique",
      text: "Une présence accessible pour les personnes qui ont besoin de parler, d'être écoutées, encouragées ou orientées vers des ressources appropriées. Du lundi au vendredi de 4 h à 19 h, et le samedi toute la journée : +1 514 621-4802.",
    },
    {
      icon: "Cross",
      title: "Accompagnement psychologique et spirituel",
      text: "Un accompagnement qui prend en compte la personne dans sa globalité : son vécu émotionnel, ses relations, ses questionnements, sa recherche de sens et, lorsqu'elle le souhaite, sa vie spirituelle et sa foi chrétienne.",
    },
    {
      icon: "Hospital",
      title: "Visite et soutien auprès des personnes malades",
      text: "Une présence humaine et réconfortante auprès des personnes hospitalisées ou vivant une période de maladie, dans le respect de leurs besoins, de leurs convictions et de leur dignité.",
    },
    {
      icon: "KeyRound",
      title: "Visite et accompagnement en milieu de détention",
      text: "Des visites d'écoute, d'encouragement et de soutien auprès des personnes incarcérées, avec une attention particulière portée à l'espoir, à la dignité et à la possibilité d'un nouveau départ.",
    },
    {
      icon: "Home",
      title: "Soutien à domicile",
      text: "Une aide et une présence auprès des personnes âgées, des personnes isolées et des familles qui traversent des difficultés particulières.",
    },
    {
      icon: "Soup",
      title: "Popote roulante et aide alimentaire",
      text: "Des repas et du soutien concret pour contribuer à répondre aux besoins essentiels des personnes et des familles en situation de vulnérabilité.",
    },
    {
      icon: "Shirt",
      title: "Dons et distribution de biens essentiels",
      text: "Collecte et distribution de vêtements, produits essentiels et autres matériels afin de répondre concrètement aux besoins des personnes et des familles dans la communauté.",
    },
  ],
  engagement: [
    "Être présents là où les besoins sont réels.",
    "Écouter sans juger.",
    "Servir avec compassion.",
    "Encourager avec espérance.",
    "Aimer par des actions concrètes.",
  ],
  engagementClosing: "Notre désir est que chaque personne puisse se sentir accueillie, considérée et soutenue — et découvrir, à travers ces gestes de compassion, l'amour et l'espérance que nous trouvons en Jésus-Christ.",
  cta: {
    heading: "Vous avez besoin de soutien ?",
    text: "Vous connaissez une personne ou une famille dans le besoin ? Nous sommes là pour vous écouter et voir avec vous comment nous pouvons vous accompagner.",
  },
};
